export default "__VITE_ASSET__PATu9qCx__"